export enum PixKeyClaimTypeEnum {
	REIVINDICACAO = 'REIVINDICACAO',
	PORTABILIDADE = 'PORTABILIDADE'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/models/key-claim-type.ts